export default __webpack_public_path__ + "static/media/Or.d028e3f8.svg";